import {
  FormControl,
  FormErrorMessage,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  VStack,
} from "@chakra-ui/react";
import React from "react";

const InputComponent = ({
  id,
  isRequired = false,
  icon,
  placeholder,
  sx,
  style,
  type = "text",
  value,
  handleChange,
  isInvalid = false,
  errorMessage = "",
  containerColor = "white",
  bg = "gray.50",
  borderColor = "gray.200",
  _focus = {},
  _hover = {},
  rightElement,
  ...props
}) => {
  return (
    <VStack spacing={1} align="stretch" w="full">
      <FormControl id={id} isRequired={isRequired} isInvalid={isInvalid}>
        <InputGroup>
          <InputLeftElement 
            pointerEvents="none" 
            h="48px"
            color="gray.400"
          >
            {icon}
          </InputLeftElement>
          <Input
            type={type}
            placeholder={placeholder}
            sx={sx}
            style={style}
            h="48px"
            borderRadius="12px"
            value={value}
            onChange={handleChange}
            color="gray.900"
            bg={bg}
            borderColor={borderColor}
            borderWidth="1px"
            fontSize="sm"
            _placeholder={{ color: "gray.400" }}
            _focus={{
              borderColor: "blue.500",
              bg: "white",
              boxShadow: "0 0 0 1px var(--chakra-colors-blue-500)",
              ..._focus
            }}
            _hover={{
              bg: "gray.100",
              ..._hover
            }}
            _invalid={{
              borderColor: "red.500",
              boxShadow: "0 0 0 1px var(--chakra-colors-red-500)"
            }}
            transition="all 0.2s"
            {...props}
          />
          {rightElement && (
            <InputRightElement h="48px">
              {rightElement}
            </InputRightElement>
          )}
        </InputGroup>
      </FormControl>
      {isInvalid && errorMessage && (
        <FormErrorMessage fontSize="xs" mt={0} mb={0}>
          {errorMessage}
        </FormErrorMessage>
      )}
    </VStack>
  );
};

export default InputComponent;
